import { render, staticRenderFns } from "./ProjectTextBoxSearch.vue?vue&type=template&id=5ec8e6f6&scoped=true&"
import script from "./ProjectTextBoxSearch.vue?vue&type=script&lang=ts&"
export * from "./ProjectTextBoxSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8e6f6",
  null
  
)

export default component.exports